module.exports = __webpack_public_path__ + "img/sign-option.33f51278.png";